import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment-timezone";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/shared/Services/data.service";
import { Subscription } from "rxjs";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import { takeUntil } from "rxjs/operators";
import { EChartsOption } from "echarts";
import { TemplateRef } from "@angular/core";
import { AuthfakeauthenticationService } from "../../../core/services/authfake.service";

@Component({
  selector: "app-langing-page",
  templateUrl: "./langing-page.component.html",
  styleUrls: ["./langing-page.component.scss"],
})
export class LangingPageComponent implements OnInit, OnDestroy {
  @ViewChild("downtime", { static: true }) downtimeTemplate: TemplateRef<any>;
  @ViewChild("hourlyProduction", { static: true })
  hourlyProductionTemplate: TemplateRef<any>;
  @ViewChild("hourlyRejection", { static: true })
  hourlyrejectionTemplate: TemplateRef<any>;
  private destroy$: Subject<void> = new Subject<void>();
  private cancelPreviousRequests$ = new Subject<void>();
  marqueeReady = false;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize;
  losshourOptions: EChartsOption = {};
  losshourChartInstance: any;
  productionhourChartInstance: any;
  custId;
  avail: any;
  m_effic: any;
  perf: any;
  quality: any;
  selectedDepartment: any;
  user: any;
  timeZone: any;
  selectedOeeDay = "today";
  selectedEnergyDay = "today";
  selectedRevenueDay = "today";
  selectedProductionDay = "today";
  oeeChartOption: any;
  energycostOp: any;
  revanuecostOp: any;
  energyChartOption: any;
  revenueChartOption: any;
  productionChartOption: any;
  statusChartOption: any;
  partcountChartOption: any;
  machDowntime: any;
  searchTerm: any;
  buttons: string[] = ["Production", "Rejection", "Downtime", "Department"];
  productionDatas: any = [];
  statusDatas: any = [];
  selectedButton: string = "Production";
  bubbles: { left: number }[] = [];
  subscriptions: Subscription[] = [];
  ltu: any;
  currentShiftData: any;
  shiftArr: any = [];
  insightsData: any = [];
  showload: boolean = false;
  showloadCost: boolean = false;
  showload2: boolean = false;
  showloadStatus: boolean = false;
  showloadRejection: boolean = false;
  deviceStatus: boolean = false;
  showload3: boolean = false;
  oeeDatas: any = {};
  energyData: any = [];
  revenueData: any = [];
  alerData: any = [];
  customerList: any = [];
  customerId: any;
  selectedCustomerId: any;
  role: any = [];
  rejectionOption: any;
  rejectionHourly: any;
  chartData: any = [];
  counts = {
    Running: 0,
    Idle: 0,
    Off: 0,
    Breakdown: 0,
    Interlock: 0
  };
  productionHourlyMap: any = {};
  rejectionHourlyMap: any = {};
  machines: any = [];
  displayedResponse: any = null;
  typingText = "";
  currentIndex = 0;
  responseData = [];
  perfAlertData: any = [];
  revenueLossAlertData: any = [];
  machineoperationData: any = [];
  energyAlertData: any = [];
  breadCrumbItems = [
    { label: "Configuration" },
    { label: "Cost", active: true },
  ];
  departmentData: any = [];
  selectedDepartmentShift: any = [];
  departmentcurrentShiftData: any;
  filteredData = [];
  showoploadCost = true;
  statusData1: any = [];
  rejectiondata: any = [];
  rejectionMachines: any = [];
  groupedData = [];
  machine_status: any = [];
  departalerData: any = []
  dapartperfAlertData: any = []
  hasBreakdown: boolean = false;
  hasinterlock: boolean = false
  hasOff: boolean = false;
  hasIdle: boolean = false
  hasRunning: boolean = false
  showDepartmentTable: boolean = true;
  departmentOeeData:any=[]
  isActingAsCustomer: boolean = false;
 
  
  constructor(
    private router: Router,
    private dataService: DataService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private currShift: GetCurrentShift,
    private authFakeService: AuthfakeauthenticationService
  ) {
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.role = this.user["user"]["role"];
    this.timeZone = this.user.user.timeZone;
    this.custId = this.user["user"]["custId"];
    this.isActingAsCustomer = !!sessionStorage.getItem("superUser");
  }

  returnToOemAdmin() {
    const superUserStr = sessionStorage.getItem("superUser");
    if (superUserStr) {
      const superUser = JSON.parse(superUserStr);
      this.authFakeService.updateCurrentUser(superUser);
      sessionStorage.removeItem("actingAsCustomer");
      this.toastr.info("Returned to OEM Admin Portal");
      this.router.navigate(["/oemAdmin"]);
    } else {
      this.toastr.error("No active superuser session found.");
      this.router.navigate(["/account/login"]);
    }
  }
  ngOnInit(): void {
    this.oeeChart(0, "today");
    this.energycostOption(0, "today");
    this.revenuecostOption(0, "today");
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.timeZone = this.user.user.timeZone;
    this.spinner.show();
    this.showload = true;
    this.showloadCost = true;
    this.showload2 = true;
    this.showloadStatus = true;
    this.showloadRejection = true;
    this.deviceStatus = true;
    this.showload3 = true;
    if (this.role == "SUPERADMIN") {
      this.getUser();
    } else {
      this.auditLogs();
      this.refreshClick();
    }
  }
  auditLogs() {
    let obj = {
      custID: this.custId
    }
    const subscription = this.dataService
      .reportApi(
        "auditlog/plant",
        obj
      )
      .subscribe(
        (res) => {
        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }
  refreshClick() {
    this.selectedOeeDay = "today";
    this.selectedEnergyDay = "today";
    this.selectedRevenueDay = "today";
    this.selectedProductionDay = "today";
    this.cancelPreviousRequests$.next();
    this.getDepartment(this.custId);
    this.getshiftDetails();
    this.getAlertData();
  }
  getDepartment(custId) {
    this.departmentData = [];
    this.dataService.get(`department?custId=${custId}`).subscribe(
      (res: any) => {
        if (res) {
          this.departmentData = res["data"];
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.selectedDepartmentShift = this.departmentData[0]["shiftData"];
          this.departmentcurrentShiftData = this.currShift.getCurrentShift(
            this.selectedDepartmentShift,
            this.timeZone
          );
          // if (this.departmentcurrentShiftData != undefined) {
          //   this.getdepartmentAlertData()
          //   this.getproductionData();
          //   this.statusData();
          //   this.rejectionData();
          //   this.getDowntimeData();
          // }
        }
      },
      (error) => {
        this.toastr.error("Server Unreachable", error.error);
      }
    );
  }
  getdepartmentAlertData() {
    var obj = {
      "custID": this.custId,
      "department": this.selectedDepartment
    };
    const subscription = this.dataService
      .plantApi(
        "notificationStatus",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.departalerData = res["perfAlertData"];
            this.dapartperfAlertData = this.departalerData.filter(i => i.machineType !== 'no_part');
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
          this.dapartperfAlertData = []
          this.departalerData = []

        }
      );
    this.subscriptions.push(subscription);
  }
  getshiftDetails() {
    this.shiftArr = [];
    const subscription = this.dataService
      .get(`api/shift?custId=${this.custId}`)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        if (res) {
          this.shiftArr = res;
          this.currentShiftData = this.currShift.getCurrentShift(
            this.shiftArr,
            this.timeZone
          );
          if (this.currentShiftData != undefined) {
            this.insightData();
            this.oeeData();
            this.costData();
            this.livestatus();
            this.oppertunitycostData();
          }
        }
      });
    this.subscriptions.push(subscription);
  }
  livestatus() {
    var obj = {
      custID: this.custId,
    };

    const subscription = this.dataService
      .plantApi(
        "plant_status",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res) {
            let statusFlags = {
              Breakdown: false,
              Interlock: false,
              Idle: false,
              Off: false,
              Running: false,
            };
            this.responseData = res["machine_status"] || [];
            for (const { status } of this.responseData) {
              if (status in statusFlags) {
                statusFlags[status] = true;
              }
            }

            this.hasBreakdown = statusFlags.Breakdown;
            this.hasinterlock = statusFlags.Interlock;
            this.hasIdle = statusFlags.Idle;
            this.hasOff = statusFlags.Off;
            this.hasRunning = statusFlags.Running;
            // this.hasBreakdown = this.responseData.some((el) => el.status === "Breakdown")
            // this.hasinterlock = this.responseData.some((el) => el.status === "Interlock")
            // this.hasIdle = this.responseData.some((el) => el.status === "Idle")
            // this.hasOff = this.responseData.some((el) => el.status === "Off")
            // this.hasRunning = this.responseData.some((el) => el.status === "Running")
            this.calculateCounts(this.hasBreakdown, this.hasinterlock);
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
        }
      );
    this.subscriptions.push(subscription);
  }
  calculateCounts(hasBreakdown, hasinterlock) {
    this.counts = { Running: 0, Idle: 0, Off: 0, Breakdown: 0, Interlock: 0 };
    if (!hasBreakdown) {
      delete this.counts.Breakdown
    }
    if (!hasinterlock) {
      delete this.counts.Interlock
    }
    for (const item of this.responseData) {
      if (this.counts.hasOwnProperty(item.status)) {
        this.counts[item.status]++;
      }
    }
  }
  getUser() {
    this.cancelPreviousRequests$.next();
    this.dataService
      .get("api/user")
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        let response = res;
        var custList = response.filter((val) => {
          return val.name !== "SUPERADMIN";
        });
        this.validate_customer(custList);
      });
  }
  validate_customer(data) {
    const filteredData = data.filter((item) => {
      return (
        item.status &&
        Array.isArray(item.status.deviceDetails) &&
        item.status.deviceDetails.length > 0
      );
    });
    this.customerList = filteredData.map((item) => {
      return {
        custName: item.status.customerName,
        custId: item.status.custId,
        deviceList: item.status.deviceDetails,
        timeZone: item.timeZone,
      };
    });
    var custshiftData = sessionStorage.getItem("Selected_CustomerID");
    this.timeZone = sessionStorage.getItem("Selected_CustomerTimeZone");

    if (custshiftData === null) {
      this.customerId = this.customerList[9]["custId"];
      this.custId = this.customerId;
      this.selectedCustomerId = this.customerList[9];
      this.timeZone = this.selectedCustomerId.timeZone
      sessionStorage.setItem(
        "Selected_CustomerName",
        this.selectedCustomerId.custName
      );
      sessionStorage.setItem(
        "Selected_CustomerID",
        this.selectedCustomerId.custId
      );
      sessionStorage.setItem(
        "Selected_CustomerTimeZone",
        this.selectedCustomerId.timeZone
      );
      this.refreshClick();
      this.filterByCustId(this.customerId);
    } else {
      this.customerId = custshiftData;
      this.custId = this.customerId;

      this.refreshClick();
      let selected = this.customerList.filter((val) => {
        return val.custId == custshiftData;
      });
      this.selectedCustomerId = selected[0];
      this.filterByCustId(this.selectedCustomerId.custId);
    }
  }
  filterByCustId(custId: string): void {
    this.filteredData = this.customerList.filter(
      (customer) => customer.custId === custId
    );
  }
  onChange(custId: any) {
    this.departmentOeeData=[]
    this.backToDepartmentTable()
    this.departalerData = [];
    this.dapartperfAlertData = [];
    this.productionHourlyMap = {};
    this.rejectionHourlyMap = {};
    this.counts = {
      Running: 0,
      Idle: 0,
      Off: 0,
      Breakdown: 0,
      Interlock: 0
    };
    this.oeeChart(0, "today");
    this.energycostOption(0, "today");
    this.revenuecostOption(0, "today");
    this.responseData = [];
    this.spinner.show();
    this.showload = true;
    this.showloadCost = true;
    this.showload2 = true;
    this.showload3 = true;
    this.showloadStatus = true;
    this.showloadRejection = true;
    this.deviceStatus = true;

    this.oeeDatas = {};
    this.energyData = [];
    this.revenueData = [];
    this.alerData = [];
    this.departmentData = [];
    this.selectedDepartment = "";
    this.chartData = [];
    this.perfAlertData = [];
    this.revenueLossAlertData = [];
    this.machineoperationData = [];
    this.energyAlertData = [];
    this.statusData1 = [];
    this.rejectionMachines = [];
    this.machines = [];
    this.avail = 0;
    this.m_effic = 0;
    this.perf = 0;
    this.quality = 0;
    this.productionDatas = [];
    this.statusDatas = [];
    this.insightsData = [];
    this.marqueeReady = false;
    sessionStorage.setItem("Selected_CustomerName", custId.custName);
    sessionStorage.setItem("Selected_CustomerID", custId.custId);
    sessionStorage.setItem("Selected_CustomerTimeZone", custId.timeZone);
    this.filterByCustId(custId.custId);
    this.customerId = custId.custId;
    this.custId = this.customerId;
    this.timeZone = custId.timeZone;
    this.refreshClick();
  }
  getDowntimeData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.departmentcurrentShiftData["currentDate"]).format(
          "YYYY-MM-DD"
        ),
        moment(this.departmentcurrentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
      department: this.selectedDepartment,
    };
    const subscription = this.dataService
      .plantApi(
        "plant_downtimeReasons",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.chartData = res;
            this.downtimeLoss(this.chartData, this.selectedProductionDay);
          } else {
            this.downtimeLoss(this.chartData, this.selectedProductionDay);
          }
        },
        (error) => {
          this.downtimeLoss(this.chartData, this.selectedProductionDay);

          this.toastr.error("Server Unreachable", error);
          this.chartData = [];
        }
      );
    this.subscriptions.push(subscription);
  }
  getAlertData() {
    var obj = {
      custID: this.custId,
    };
    const subscription = this.dataService
      .plantApi(
        "notificationStatus",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.alerData = res;
            this.perfAlertData = this.alerData["perfAlertData"];

            this.revenueLossAlertData = this.alerData["revenueLossAlertData"];
            this.machineoperationData = this.alerData["off_devices"];
            this.energyAlertData = this.alerData["energyAlertData"];
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
          this.alerData = [];
        }
      );
    this.subscriptions.push(subscription);
  }
  departmentoeetoday:any=[]
  oeeData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.currentShiftData["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
    };

    const subscription = this.dataService
      .plantApi(
        "plant_oee",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            const rawLut = res?.["LUT"];
            if (rawLut != null) {
              const lutTimestamp = Number(rawLut);
              this.ltu = moment
                .tz(lutTimestamp, this.timeZone)
                .format("YYYY-MM-DD HH:mm:ss");
            } else {
              this.ltu = null;
            }
            this.oeeDatas = res?.["plantOEE"];
            this.departmentOeeData = res?.["departmentOEE"]?.['today']
            this.oeeChart(this.oeeDatas, "today");
            this.showload = false;
            this.spinner.hide();
          } else {
            this.showload = false;
            this.spinner.hide();
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.showload = false;
          this.oeeDatas = {};
          this.spinner.hide();
        }
      );
    this.subscriptions.push(subscription);
  }
  costData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.currentShiftData["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
    };

    const subscription = this.dataService
      .plantApi(
        "plant_energyCost",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.energyData = res?.["EnergyCostdata"] || [];
            this.energycostOption(this.energyData, "today");

            this.showloadCost = false;
            this.spinner.hide();
          } else {
            this.showloadCost = false;
            this.spinner.hide();
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.showloadCost = false;
          this.spinner.hide();
        }
      );
    this.subscriptions.push(subscription);
  }
  oppertunitycostData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.currentShiftData["currentDate"]).format("YYYY-MM-DD"),
        moment(this.currentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
    };

    const subscription = this.dataService
      .plantApi(
        "plant_opportunityCost",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.revenueData = res?.["opportunityCostData"] || [];
            this.revenuecostOption(this.revenueData, "today");

            this.showoploadCost = false;
            this.spinner.hide();
          } else {
            this.showoploadCost = false;
            this.spinner.hide();
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.showoploadCost = false;
          this.spinner.hide();
        }
      );
    this.subscriptions.push(subscription);
  }
  statusData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.departmentcurrentShiftData["currentDate"]).format(
          "YYYY-MM-DD"
        ),
        moment(this.departmentcurrentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
      department: this.selectedDepartment,
    };
    const subscription = this.dataService
      .plantApi(
        "plant_operationChart",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res) {
            this.deviceStatus = false;
            this.statusDatas = res;
            this.statusChart(this.statusDatas, this.selectedProductionDay);
            this.spinner.hide();
          } else {
            this.deviceStatus = false;
            this.spinner.hide();
            this.statusChart(this.statusDatas, this.selectedProductionDay);
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.statusChart(this.statusDatas, this.selectedProductionDay);

          this.spinner.hide();
          this.deviceStatus = false;
          this.statusDatas = [];
        }
      );
    this.subscriptions.push(subscription);
  }
  getproductionData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.departmentcurrentShiftData["currentDate"]).format(
          "YYYY-MM-DD"
        ),
        moment(this.departmentcurrentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
      department: this.selectedDepartment,
    };
    const subscription = this.dataService
      .plantApi(
        "plant_production",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res) {
            this.showloadStatus = false;
            this.statusData1 = res["productiondata"] || [];
            this.machines =
              this.statusData1[this.selectedProductionDay]["machines"];
            this.productionChart(this.statusData1, this.selectedProductionDay);
            this.spinner.hide();
          } else {
            this.productionChart(this.statusData1, this.selectedProductionDay);
            this.showloadStatus = false;
            this.spinner.hide();
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.showloadStatus = false;
          this.spinner.hide();
          this.productionChart(this.statusData1, this.selectedProductionDay);

          this.statusData1 = [];
        }
      );
    this.subscriptions.push(subscription);
  }
  rejectionData() {
    var obj = {
      custID: this.custId,
      date: [
        moment(this.departmentcurrentShiftData["currentDate"]).format(
          "YYYY-MM-DD"
        ),
        moment(this.departmentcurrentShiftData["currentDate"])
          .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ],
      department: this.selectedDepartment,
    };
    const subscription = this.dataService
      .plantApi(
        "plant_rejectionsPart",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.showloadRejection = false;
            this.rejectiondata = res["productiondata"] || [];
            this.rejectionMachines =
              this.rejectiondata[this.selectedProductionDay]["machines"];
            this.rejection(this.rejectiondata, this.selectedProductionDay);
          } else {
            this.showloadRejection = false;
            this.rejection(this.rejectiondata, this.selectedProductionDay);
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable", error.error);
          this.showloadRejection = false;
          this.rejection(this.rejectiondata, this.selectedProductionDay);
          this.rejectiondata = [];
          this.rejectionMachines = [];
        }
      );
    this.subscriptions.push(subscription);
  }
  insightData() {
    var obj = {
      custID: this.custId,
      shiftName: this.currentShiftData?.usershiftId,
    };
    const subscription = this.dataService
      .plantApi(
        "plant_insights",
        obj
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.marqueeReady = true;
            this.insightsData = res?.["machine_data"] || [];
            this.machine_status = res?.["machine_status"] || [];
            this.groupedData = this.machine_status.map((group, index) => ({
              ...group,
              expanded: index === 0,
            }));
            this.showload3 = false;
            this.spinner.hide();
          } else {
            this.showload3 = false;
            this.marqueeReady = false;
            this.spinner.hide();
          }
        },
        (error) => {
          this.insightsData = [];
          this.machine_status = [];
          this.spinner.hide();
          this.showload3 = false;
          this.marqueeReady = false;
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }
  selectButton(button: string): void {
    this.selectedButton = button;
    if (this.selectedButton == "Department") {
      if (this.role != "SUPERADMIN") {
        this.router.navigate(["/liveDashboard"]);
      } else {
        this.router.navigate(["/admin"]);
      }
    } else if (this.selectedButton == "Downtime") {
      this.downtimeLoss(this.chartData, this.selectedProductionDay);
    } else if (this.selectedButton == "Rejection") {
      this.rejection(this.rejectiondata, this.selectedProductionDay);
    } else if (this.selectedButton == "Production") {
      this.productionChart(this.statusData1, this.selectedProductionDay);
    }
  }
  gotodepartment(){
       if (this.role != "SUPERADMIN") {
        this.router.navigate(["/liveDashboard"]);
      } else {
        this.router.navigate(["/admin"]);
      }
  }
  onDayChange(val) {
    this.oeeChart(this.oeeDatas, val);
  }
  onenergyDayChange(val) {
    this.energycostOption(this.energyData, val);
  }
  onrevenueDayChange(val) {
    this.revenuecostOption(this.revenueData, val);
  }
  onproductionDayChange(val) {
    this.machines = this.statusData1[val]["machines"];
    this.rejectionMachines = this.rejectiondata[val]["machines"];
    this.productionChart(this.statusData1, val);
    this.statusChart(this.statusDatas, val);
    this.rejection(this.rejectiondata, val);
    this.downtimeLoss(this.chartData, val);
  }
  ondepartmentChange(val: any) {
    this.productionHourlyMap = {};
    this.rejectionHourlyMap = {};
    let data = this.departmentData.filter(
      (el) => el.departmentName == this.selectedDepartment
    );
    this.selectedDepartmentShift = data[0]["shiftData"];
    this.departmentcurrentShiftData = this.currShift.getCurrentShift(
      this.selectedDepartmentShift,
      this.timeZone
    );
    if (this.departmentcurrentShiftData != undefined) {
      this.getdepartmentAlertData();
      this.getproductionData();
      this.statusData();
      this.rejectionData();
      this.getDowntimeData();
    }
  }
  oeeChart(data: any, val: any) {
    const avgOee = data?.[val]?.[0]?.avg_oee ?? 0;
    this.oeeChartOption = {
      series: [
        {
          type: "gauge",
          startAngle: 225,
          endAngle: -45,
          min: 0,
          max: 100,
          radius: "100%",
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              width: 25,
              color: [
                [0.5, "#FF6B6B"],
                [0.8, "#FFD93D"],
                [1, "#6BCB77"],
              ],
            },
          },
          pointer: {
            show: true,
            length: "70%",
            width: 4,
          },
          detail: {
            valueAnimation: true,
            formatter: "OEE {value}%",
            color: "black",
            fontSize: 16,
            fontWeight: "bold",
            offsetCenter: [0, "80%"],
          },
          data: [
            {
              value: avgOee || 0,
              name: "OEE",
            },
          ],
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          title: {
            show: false,
          },
        },
      ],
    };
  }
  energycostOption(data: any, day: any) {
    const isToday = day === "today";
    const asofNow = data[day]?.["todaySum"] || 0;
    const currentHour = moment().format("h A");
    const expected = data[day]?.["expectedEnergyCost"] || 0;
    const yesterDayAsofNow = data[day]?.liveHourEnergycost || 0;
    const yesterday = data[day]?.["yesterdaySum"] || 0;
    const dailyAvg = data[day]?.["monthlyAverage"] || 0;

    this.energycostOp = {
      title: [
        {
          text: isToday
            ? `As of Now : ₹ ${asofNow}`
            : `As of ${currentHour} : ₹ ${yesterDayAsofNow}`,
          top: "50%",
          left: "0%",
          textStyle: { fontSize: 12, color: "#333" },
        },
        // {
        //   text: `Daily Avg : ₹ ${dailyAvg}`,
        //   top: "75%",
        //   left: "0%",
        //   textStyle: { fontSize: 12, color: "#333" },
        // },
        {
          text: isToday ? `Expected : ₹ ${expected}` : `Total : ₹ ${asofNow}`,
          top: "50%",
          right: "0%",
          textStyle: { fontSize: 12, color: "#333" },
        },
      ],
      xAxis: {
        type: "value",
        max: isToday ? expected : asofNow,
        show: false,
      },
      yAxis: {
        type: "category",
        data: [""],
        show: false,
      },
      series: [
        {
          type: "bar",
          data: [isToday ? asofNow : yesterDayAsofNow],
          barWidth: 15,
          itemStyle: {
            color: "#4A90E2",
            borderRadius: 200,
          },
        },
        {
          type: "bar",
          data: [isToday ? expected : asofNow],
          barWidth: 15,
          barGap: "-100%",
          itemStyle: {
            color: "#eee",
            borderRadius: 200,
          },
          silent: true,
          emphasis: {
            disabled: true, // 👈 Prevent hover interaction on this bar
          },
          z: -1,
        },
        // {
        //   type: "line",
        //   data: [],
        //   markLine: {
        //     symbol: ["none"],
        //     label: {
        //       show: true,
        //       formatter: `Yesterday ₹${yesterday}`,
        //       position: "end",
        //       distance: -15,
        //       color: "#333",
        //       fontSize: 12,
        //       fontWeight: "bold",
        //     },
        //     lineStyle: {
        //       color: "#999",
        //       type: "dashed",
        //       width: 1,
        //     },
        //     data: [{ xAxis: yesterday }],
        //   },
        // },
      ],
      grid: {
        top: "0%",
        left: "1%",
        right: "1%",
        bottom: "1%",
        containLabel: true,
      },
    };
  }
  revenuecostOption(data: any, day: any) {
    const isToday = day === "today";
    const asofNow = data[day]?.["todaySum"] || 0;
    const currentHour = moment().format("h A");
    const expected = data[day]?.["expectedRevenueLoss"] || 0;
    const yesterDayAsofNow = data[day]?.liveHourRevenueLoss || 0;
    const yesterdaySum = data[day]?.["yesterdaySum"] || 0;
    const dailyAvg = data[day]?.["monthlyAverage"] || 0;
    this.revanuecostOp = {
      title: [
        {
          text: isToday
            ? `As of Now : ₹ ${asofNow}`
            : `As of ${currentHour} : ₹ ${yesterDayAsofNow}`,
          top: "50%",
          left: "0%",
          textStyle: { fontSize: 12, color: "#333" },
        },
        // {
        //   text: `Daily Avg : ₹ ${dailyAvg}`,
        //   top: "75%",
        //   left: "0%",
        //   textStyle: { fontSize: 12, color: "#333" },
        // },
        {
          text: isToday ? `Expected : ₹ ${expected}` : `Total : ₹ ${asofNow}`,
          top: "50%",
          right: "0%",
          textStyle: { fontSize: 12, color: "#333" },
        },
      ],
      xAxis: {
        type: "value",
        max: isToday ? expected : asofNow,
        show: false,
      },
      yAxis: {
        type: "category",
        data: [""],
        show: false,
      },
      series: [
        {
          type: "bar",
          data: [isToday ? asofNow : yesterDayAsofNow],
          barWidth: 15,
          itemStyle: {
            color: "#4A90E2",
            borderRadius: 200,
          },
        },
        {
          type: "bar",
          data: [isToday ? expected : asofNow],
          barWidth: 15,
          barGap: "-100%",
          itemStyle: {
            color: "#eee",
            borderRadius: 200,
          },
          silent: true,
          emphasis: {
            disabled: true,
          },
          z: -1,
        },
        // {
        //   type: "line",
        //   data: [],
        //   markLine: {
        //     symbol: ["none"],
        //     label: {
        //       show: true,
        //       formatter: `Yesterday ₹${yesterdaySum}`,
        //       position: "end",
        //       distance: -15,
        //       color: "#333",
        //       fontSize: 12,
        //       fontWeight: "bold",
        //     },
        //     lineStyle: {
        //       color: "#999",
        //       type: "dashed",
        //       width: 1,
        //     },
        //     data: [{ xAxis: yesterdaySum }],
        //   },
        // },
      ],
      grid: {
        top: "0%",
        left: "1%",
        right: "1%",
        bottom: "1%",
        containLabel: true,
      },
    };
  }
  productionChart(data: any, day: any) {
    if (!data || data.length === 0 || !data?.[day]) {
      this.productionChartOption = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }

    const isMobile = window.innerWidth < 768;
    const producedCount = data?.[day].producedCount ?? 0;
    const targetCount = data?.[day].targetCount ?? 0;
    const elapsedHours = data?.[day].completedHour ?? 0;
    const totalHours = data?.[day].totalHours ?? 0;
    const remainingParts = Math.max(targetCount - producedCount, 0);
    const remainingHours = totalHours - elapsedHours;
    const produeced = data?.[day]?.hourlyProduced?.length
      ? data?.[day]?.hourlyProduced?.[data[day].hourlyProduced.length - 1]
      : "0";
    const excess = data?.[day]?.hourlyExceeded?.length
      ? data?.[day]?.hourlyExceeded?.[data[day].hourlyExceeded.length - 1]
      : "0";
    const currentRate = produeced + excess;

    // Target & percentage handling
    const targetText = targetCount > 0 ? `Target: ${targetCount}` : `Target: NA`;
    const completedPercentage =
      targetCount > 0
        ? Math.max(
          0,
          Math.min(100, (producedCount / targetCount) * 100)
        ).toFixed(0)
        : null;
    const remainingPercentage =
      targetCount > 0
        ? Math.max(
          0,
          Math.min(100, ((targetCount - producedCount) / targetCount) * 100)
        ).toFixed(0)
        : null;

    // Required rate handling
    const requiredRate =
      targetCount > 0 && remainingHours
        ? (remainingParts / remainingHours).toFixed(0)
        : "NA";


    const hourlyProduced = data?.[day].hourlyProduced || [];
    const hourlyExceeded = data?.[day].hourlyExceeded || [];
    const hourlyRemaining = data?.[day].hourlyRemaining || [];
    const hourlyTime = data?.[day].hours || [];
    const hourlyTarget = data?.[day].hourlyTarget ?? 0;

    const allZeroProduced = hourlyProduced.every((v) => v === 0);
    const allZeroRemaining = hourlyRemaining.every((v) => v === 0);
    const allZeroExceeded = hourlyExceeded.every((v) => v === 0);

    const filteredHourlyProduced = hourlyProduced.map((v) =>
      v === 0 ? null : v
    );
    const filteredHourlyRemaining = hourlyRemaining.map((v) =>
      v === 0 ? null : v
    );
    const filteredHourlyExceeded = hourlyExceeded.map((v) =>
      v === 0 ? null : v
    );

    if (allZeroProduced && hourlyTime.length > 0) {
      filteredHourlyProduced[0] = 0.0001;
    }
    if (allZeroRemaining && hourlyTime.length > 0) {
      filteredHourlyRemaining[0] = 0.0001;
    }
    if (allZeroExceeded && hourlyTime.length > 0) {
      filteredHourlyExceeded[0] = 0.0001;
    }

    const currentRateTitle = isMobile
      ? `C.R: ${currentRate}/hr`
      : `Current Rate: ${currentRate}/hr`;
    const requiredRateTitle =
      targetCount > 0
        ? isMobile
          ? `R.P: ${requiredRate}/hr`
          : `Required Rate: ${requiredRate}/hr`
        : "Required Rate: NA";

    // Progress bar (top chart)
    const stockSeries = [
      {
        type: "bar",
        data: [producedCount],
        stack: "progress_today",
        xAxisIndex: 0,
        yAxisIndex: 0,
        barWidth: 20,
        roundCap: true,
        itemStyle: { color: "#1cbb8c" },
        label: {
          show: true,
          position: producedCount === 0 ? "left" : "inside",
          color: "black",
          fontWeight: "bold",
          formatter:
            targetCount > 0
              ? `${producedCount} (${completedPercentage}%)`
              : `${producedCount}`,
        },
        tooltip: { show: false },
      },
    ];

    if (targetCount > 0 && remainingParts > 0) {
      stockSeries.push({
        type: "bar",
        data: [remainingParts],
        stack: "progress_today",
        xAxisIndex: 0,
        yAxisIndex: 0,
        barWidth: 20,
        roundCap: true,
        itemStyle: { color: "#E9762B" },
        label: {
          show: true,
          position: "inside",
          color: "black",
          fontWeight: "bold",
          formatter: `${remainingParts} (${remainingPercentage}%)`,
        },
        tooltip: { show: false },
      });
    }

    // Hourly stacked bars (bottom chart)
    const hourlySeries: any[] = [
      {
        name: "Produced",
        data: filteredHourlyProduced,
        type: "bar",
        stack: "hourly_progress",
        xAxisIndex: 1,
        yAxisIndex: 1,
        color: "#1cbb8c",
        label: {
          show: true,
          position: "inside",
          color: "black",
          fontWeight: "bold",
          formatter: (params: any) =>
            params.value ? params.value.toFixed(0) : "",
        },
        markLine: {
          symbol: "none",
          lineStyle: { color: "#3A7D44", type: "dashed", width: 1 },
          tooltip: { show: false },
          label: {
            color: "#3A7D44",
            fontWeight: "bold",
            fontSize: 12,
            backgroundColor: "white",
            padding: [2, 2],
            borderRadius: 4,
          },
          data: [
            {
              yAxis: hourlyTarget,
              label: { position: "start", formatter: `${hourlyTarget}` },
            },
            {
              yAxis: hourlyTarget,
              label: { position: "end", formatter: "Target" },
            },
          ],
        },
      },
    ];

    if (!allZeroRemaining) {
      hourlySeries.push({
        name: "ProductionLoss",
        data: filteredHourlyRemaining,
        type: "bar",
        stack: "hourly_progress",
        xAxisIndex: 1,
        yAxisIndex: 1,
        color: "#E9762B",
        label: {
          show: true,
          position: "inside",
          color: "black",
          fontWeight: "bold",
          formatter: (params: any) =>
            params.value ? params.value.toFixed(0) : "",
        },
      });
    }
    if (!allZeroExceeded) {
      hourlySeries.push({
        name: "ExcessCount",
        data: filteredHourlyExceeded,
        type: "bar",
        stack: "hourly_progress",
        xAxisIndex: 1,
        yAxisIndex: 1,
        color: "#B17F59",
        label: {
          show: true,
          position: "inside",
          color: "black",
          fontWeight: "bold",
          formatter: (params: any) =>
            params.value ? params.value.toFixed(0) : "",
        },
      });
    }

    // Dynamic Y-axis max calculation
    const yMax = Math.max(
      hourlyTarget,
      ...hourlyProduced,
      ...hourlyRemaining,
      ...hourlyExceeded
    );
    const paddedMax = yMax > 0 ? Math.ceil(yMax * 1.2) : 10;

    // Final chart options
    this.productionChartOption = {
      title: [
        {
          text: `Produced`,
          top: "5%",
          left: "4%",
          textStyle: { fontSize: 12, color: "#333" },
        },
        {
          text: targetText,
          top: "5%",
          right: "5%",
          textStyle: { fontSize: 12, color: "#333" },
        },
        {
          text: currentRateTitle,
          top: "19%",
          left: "4%",
          textStyle: { fontSize: 12, color: "#3A7D44", fontWeight: "bold" },
        },
        {
          text: requiredRateTitle,
          top: "19%",
          right: "5%",
          textStyle: { fontSize: 12, color: "#E94F37", fontWeight: "bold" },
        },
      ],
      grid: [
        { top: "5%", left: "5%", right: "5%", height: "20%" },
        {
          top: "40%",
          left: "5%",
          right: "10%",
          bottom: "5%",
          containLabel: true,
          height: "55%",
        },
      ],
      legend: {
        show: true,
        orient: "horizontal",
        top: 80,
        left: "center",
        textStyle: { fontSize: 12 },
        itemWidth: 10,
        itemHeight: 10,
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const time = params.name;
          this.productionHourlyMap = {};
          hourlyTime.forEach((t: string, index: number) => {
            this.productionHourlyMap[t] = {
              produced: hourlyProduced[index] ?? 0,
              productionLoss: hourlyRemaining[index] ?? 0,
              productionExcess: hourlyExceeded[index] ?? 0,
            };
          });
          const d = this.productionHourlyMap[time];
          if (!d || (!d.produced && !d.productionLoss)) return "";
          return `
          <div style="font-family: Arial; font-size: 13px; line-height: 1.6;">
            <div><b>Time:</b> ${time}</div>
            <div><b>Produced:</b> ${d.produced}</div>
            <div><b>ProductionLoss:</b> ${d.productionLoss}</div>
            <div><b>ProductionExcess:</b> ${d.productionExcess}</div>
            <div style="margin-top: 4px; color: #007BFF; font-style: italic; font-weight: bold;">
              Click to see Machine Level Production
            </div>
          </div>
        `;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333" },
      },
      xAxis: [
        { type: "value", max: targetCount, show: false, gridIndex: 0 },
        {
          type: "category",
          data: hourlyTime,
          gridIndex: 1,
          name: "Time (Hours)",
          nameLocation: "middle",
          nameGap: 20,
          nameTextStyle: { fontWeight: "bold", color: "#000" },
          axisLabel: { color: "#000" },
        },
      ],
      yAxis: [
        { type: "category", data: [""], show: false, gridIndex: 0 },
        {
          type: "value",
          gridIndex: 1,
          min: 0,
          max: paddedMax,
          name: "Count",
          nameLocation: "middle",
          nameGap: 40,
          nameRotate: 90,
          nameTextStyle: { fontWeight: "bold", color: "#000" },
          axisLabel: { color: "#000" },
        },
      ],
      series: [...stockSeries, ...hourlySeries],
    };
  }
  statusChart(data: any, day: any) {
    const status = data?.[day]?.["Machine_duration"] ?? {};
    const statusColors = {
      running: "#548237",
      idle: "#f7c030",
      breakdown: "#eb5857",
      interlock: "#7B542F",
      off: "#b0b0b0",
    };

    let chartData = [
      { value: status.running ?? 0, name: "running" },
      { value: status.idle ?? 0, name: "idle" },
      { value: status.breakdown ?? 0, name: "breakdown" },
      { value: status.interlock ?? 0, name: "interlock" },
      { value: status.off ?? 0, name: "off" },
    ].filter((item) => item.value > 0);

    const isNoData = chartData.length === 0;
    if (isNoData) {
      chartData = [{ value: 1, name: "No Data" }];
    }

    const chartColors = isNoData
      ? ["#e0e0e0"] // Gray for "No Data"
      : chartData.map((item) => statusColors[item.name] ?? "#ccc");

    this.statusChartOption = {
      title: {
        text: "Operating Time",
        left: "center",
        textStyle: {
          fontSize: 12,
          color: "#000",
        },
      },

      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          if (isNoData) return "No data available";

          const durationInSeconds = Math.round(params.value * 60); // Round to whole seconds
          const hours = Math.floor(durationInSeconds / 3600);
          const minutes = Math.floor((durationInSeconds % 3600) / 60);
          const seconds = durationInSeconds % 60;

          const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

          return `${params.name}: (${params.percent}%)`;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
        },
      },

      color: chartColors,
      legend: {
        show: !isNoData, // Hide legend if no data
        orient: "horizontal",
        bottom: 0,
        left: "center",
        textStyle: {
          fontSize: 10,
        },
        itemWidth: 10,
        itemHeight: 10,
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          padAngle: 50,
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: true,
            position: "center",
            formatter: isNoData ? "No Data" : "",
            fontSize: 12,
            color: "#999",
          },
          labelLine: {
            show: false,
          },
          data: chartData,
        },
      ],
    };
  }
  energyChart(
    data: { [key: string]: { hour: string[]; energyCost: number[] } },
    day: string
  ) {
    const dayData = data[day];
    const hours = dayData?.hour?.length ? dayData.hour : ["00:00"];
    const costs = dayData?.energyCost?.length ? dayData.energyCost : [0];
    this.energyChartOption = {
      toolbox: {
        show: true,
        feature: {
          magicType: {
            type: ["line", "bar"],
            title: { line: "line", bar: "bar" },
          },
        },
      },
      xAxis: {
        type: "category",
        data: hours,
        name: "Time (Hours)", // Title for X Axis
        nameLocation: "middle",
        nameGap: 25, // Space between axis line and title
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        axisLabel: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 10,
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        top: "20%",
        bottom: "10%",
        containLabel: true,
      },
      yAxis: {
        type: "value",
        name: "Cost (₹)", // Title for Y Axis
        nameLocation: "middle",
        nameRotate: 90, // Rotates the text vertically
        nameGap: 60, // 35 Space between axis line and title
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        axisLabel: {
          formatter: (value: number) => `₹${value}`,
          color: "#000",
          fontWeight: "bold",
          fontSize: 10,
        },
      },
      series: [
        {
          data: costs,
          type: "line",
          smooth: true,
          emphasis: {
            focus: "series",
          },
          label: {
            show: true,
            position: "top",
            formatter: (params: any) => `₹${params.value}`,
            fontSize: 10,
            fontWeight: "bold",
            color: "#fff",
            backgroundColor: "green",
            padding: [5, 8],
            borderRadius: 5,
            borderWidth: 1,
          },
        },
      ],
    };
  }
  revenueChart(
    data: { [key: string]: { hour: string[]; revenueLoss: number[] } },
    day: string
  ) {
    const dayData = data[day];
    const hours = dayData?.hour?.length ? dayData.hour : ["00:00"];
    const costs = dayData?.revenueLoss?.length ? dayData.revenueLoss : [0];
    this.revenueChartOption = {
      toolbox: {
        show: true,
        feature: {
          magicType: {
            type: ["line", "bar"],
            title: { line: "line", bar: "bar" },
          },
        },
      },
      xAxis: {
        type: "category",
        data: hours,
        name: "Time (Hours)", // Title for X Axis
        nameLocation: "middle",
        nameGap: 25, // Space between axis line and title
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        axisLabel: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 10,
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        top: "20%",
        bottom: "10%",
        containLabel: true,
      },
      yAxis: {
        type: "value",
        name: "Cost (₹)", // Title for Y Axis
        nameLocation: "middle",
        nameRotate: 90, // Rotates the text vertically
        nameGap: 60, // 35 Space between axis line and title
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        axisLabel: {
          formatter: (value: number) => `₹${value}`,
          color: "#000",
          fontWeight: "bold",
          fontSize: 10,
        },
      },
      series: [
        {
          data: costs,
          type: "line",
          smooth: true,
          emphasis: {
            focus: "series",
          },
          label: {
            show: true,
            position: "top",
            formatter: (params: any) => `₹${params.value}`,
            fontSize: 10,
            fontWeight: "bold",
            color: "#fff",
            backgroundColor: "green",
            padding: [5, 8],
            borderRadius: 5,
            borderWidth: 1,
          },
        },
      ],
    };
  }
  rejection(data: any, day: any) {
    if (!data || data.length === 0 || !data?.[day]) {
      this.rejectionOption = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const totalProduced = data[day]?.["totalProduced"] || 0;
    const totalRejected = data[day]?.["totalRejected"] || 0;
    const hour = data[day]?.["hours"] || 0;
    const produced = data[day]?.["produced"] || 0;
    const rejected = data[day]?.["rejected"] || 0;

    this.rejectionOption = {
      title: {
        text: `Produced: ${totalProduced} | Rejected: ${totalRejected}`,
        left: "left",
        top: 10,
        textStyle: {
          fontWeight: "bold",
          fontSize: 12,
          color: "#333",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: (params: any) => {
          const time = params.name;
          this.rejectionHourlyMap = {};

          hour.forEach((time: string, index: number) => {
            this.rejectionHourlyMap[time] = {
              produced: produced[index] ?? 0,
              productionLoss: rejected[index] ?? 0,
            };
          });
          const data = this.rejectionHourlyMap[time];

          if (!data || (!data.produced && !data.productionLoss)) return "";

          return `
      <div style="font-family: Arial; font-size: 13px; line-height: 1.6;">
        <div><b>Time:</b> ${time}</div>
        <div><b>Produced:</b> ${data.produced}</div>
        <div><b>Rejected:</b> ${data.productionLoss}</div>
        <div style="margin-top: 4px; color: #007BFF; font-style: italic; font-weight: bold;">
          Click to see Machine Level Rejection
        </div>
      </div>
    `;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333" },
      },
      // tooltip: {
      //   trigger: "axis",
      //   axisPointer: {
      //     type: "shadow",
      //   },
      //   formatter: function (params) {
      //     const time = params[0]?.axisValue || "";
      //     const produced =
      //       params.find((p) => p.seriesName === "Produced")?.data || 0;
      //     const rejected =
      //       params.find((p) => p.seriesName === "Rejected")?.data ?? 0;

      //     return `
      //   <div style="font-family: Arial; font-size: 13px; line-height: 1.6;">
      //     <div><b>Time:</b> ${time}</div>
      //     <div><b>Produced:</b> ${produced}</div>
      //     <div><b>Rejected:</b> ${rejected}</div>
      //     <div style="margin-top: 4px; color: #007BFF; font-style: italic; font-weight: bold;">
      //       Click to see Machine Level Rejection
      //     </div>
      //   </div>
      // `;
      //   },
      //   backgroundColor: "#fff",
      //   borderColor: "#ccc",
      //   borderWidth: 1,
      //   textStyle: {
      //     color: "#333",
      //   },
      // },
      legend: {
        data: ["Produced", "Rejected"],
        top: 35,
        left: "center",
      },
      grid: {
        top: 80,
        left: 60,
        right: 30,
        bottom: 60,
      },
      xAxis: {
        type: "category",
        name: "Hour",
        nameLocation: "middle",
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        nameGap: 40,
        data: hour,
      },
      yAxis: {
        type: "value",
        name: "Count",
        nameLocation: "middle",
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        nameGap: 40,
      },
      series: [
        {
          name: "Produced",
          type: "bar",
          data: produced,
          barGap: 0,
          itemStyle: {
            color: "#4caf50",
          },
          label: {
            show: true,
            position: "top",
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
          },
        },
        {
          name: "Rejected",
          type: "bar",
          data: rejected,
          itemStyle: {
            color: "#f44336",
          },
          label: {
            show: true,
            position: "top",
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
            formatter: (val) => (val.data === null ? "" : val.data),
          },
        },
      ],
    };
  }
  downtimeLoss(data: any, day: any) {
    if (!data || data.length === 0 || data?.[day].length == 0) {
      this.losshourOptions = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }

    const categories = data[day].map((item) => item.reason);
    const durations = data[day].map((item) => item.duration);
    const values = data[day].map((item) => item.value);
    const machineTooltips = data[day].map((item) =>
      item.machine_data
        .map((m) => `${m.machine_name}: ${m.downtime_duration} min`)
        .join("<br/>")
    );
    const barWidth = data[day].length <= 4 ? 80 : undefined;

    this.losshourOptions = {
      // title: {
      //   text: "Downtime Reasons",
      //   left: "center",
      //   textStyle: {
      //     fontSize: 12,
      //     color: "#000000",
      //   },
      // },
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          const index = params[0].dataIndex;
          const duration = durations[index];
          const cumulativeValue = values[index];
          const total = values[values.length - 1];
          const cumulativePercentage = (
            (cumulativeValue / total) *
            100
          ).toFixed(2);

          return `
      <div style="font-family: Arial; font-size: 13px; line-height: 1.6;">
        <div><b>Reason:</b> ${categories[index]}</div>
        <div><b>Duration:</b> ${moment
              .utc(duration * 60 * 1000)
              .format("HH:mm:ss")}</div>
        <div><b>Cumulative:</b> ${cumulativePercentage}%</div>
        <div style="margin-top: 4px; color: #007BFF; font-style: italic; font-weight: bold;">
          Click to see the Machine Level Downtime 👆
        </div>
      </div>
    `;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
        },
      },
      grid: {
        top: "20%",
        left: "5%",
        right: "5%",
        bottom: "15%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: categories,
        name: "Reasons",
        nameLocation: "middle",
        nameGap: 30,
        nameTextStyle: {
          color: "#000",
          fontWeight: "bold",
          fontSize: 12,
        },
        axisLabel: {
          color: "#000",
          fontSize: 10,
          fontWeight: "bold",
        },
      },
      yAxis: [
        {
          type: "value",
          name: "Duration (min)",
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 40,
          nameTextStyle: {
            color: "#000",
            fontWeight: "bold",
            fontSize: 12,
          },
          axisLabel: {
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
          },
        },
        {
          type: "value",
          name: "Cumulative %",
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 50,
          nameTextStyle: {
            color: "#000",
            fontWeight: "bold",
            fontSize: 12,
          },
          axisLabel: {
            color: "#000",
            fontSize: 10,
            fontWeight: "bold",
            formatter: "{value}%",
          },
          max: 100,
        },
      ],
      series: [
        {
          name: "Duration",
          type: "bar",
          data: durations,
          ...(barWidth !== undefined && { barWidth }),
        },
        {
          name: "Cumulative %",
          type: "line",
          yAxisIndex: 1,
          data: values.map((v) =>
            ((v / values[values.length - 1]) * 100).toFixed(2)
          ),
          lineStyle: {
            color: "#FF9800",
          },
          itemStyle: {
            color: "#FF9800",
          },
        },
      ],
    };
  }
  onChartInit(chartInstance: any): void {
    this.losshourChartInstance = chartInstance;
    this.losshourChartInstance.off("click");
    this.losshourChartInstance.getZr().off("click");
    this.losshourChartInstance.on("click", (params: any) => {
      if (params.componentType === "series" && params.seriesType === "bar") {
        this.handleBarClick(params);
      }
    });
    this.losshourChartInstance.getZr().on("click", (event: any) => {
      const pointInGrid = this.losshourChartInstance.convertFromPixel(
        { seriesIndex: 0 },
        [event.offsetX, event.offsetY]
      );
      const xAxisIndex = Math.round(pointInGrid[0]);
      if (
        xAxisIndex >= 0 &&
        xAxisIndex < this.chartData[this.selectedProductionDay].length
      ) {
        const fakeParams = {
          dataIndex: xAxisIndex,
          componentType: "axis",
        };
        this.handleBarClick(fakeParams);
      }
    });
  }
  handleBarClick(params: any): void {
    const index = params.dataIndex;
    const clickedReason =
      this.chartData[this.selectedProductionDay][index]?.reason;
    const machineData =
      this.chartData[this.selectedProductionDay][index]?.machine_data;
    this.modalService.open(this.downtimeTemplate, {
      backdrop: "static",
      centered: true,
      size: "xl",
    });
    this.getMachDown(machineData, clickedReason);
  }
  onrejectionChartInit(params: any): void {
    this.rejectionHourly = params;

    this.rejectionHourly.off("click");

    this.rejectionHourly.on("click", (params: any) => {
      if (params.componentType === "series" && params.seriesType === "bar") {
        this.handlerejectionBarClick();
      }
    });
  }
  handlerejectionBarClick() {
    this.modalService.open(this.hourlyrejectionTemplate, {
      backdrop: "static",
      centered: true,
      size: "xl",
    });
  }
  onProductionChartInit(chartInstance: any): void {
    this.productionhourChartInstance = chartInstance;

    this.productionhourChartInstance.off("click");

    this.productionhourChartInstance.on("click", (params: any) => {
      if (
        params.componentType === "series" &&
        params.seriesType === "bar" &&
        (params.seriesName === "Produced" ||
          params.seriesName === "ProductionLoss" || params.seriesName === "ExcessCount")
      ) {
        this.handleproductionBarClick(params);
      }
    });
  }
  handleproductionBarClick(params: any): void {
    this.modalService.open(this.hourlyProductionTemplate, {
      backdrop: "static",
      centered: true,
      size: "xl",
    });
  }
  getMachDown(data, reason) {
    this.machDowntime = {
      title: {
        text: `Reason: ${reason}`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          const data = params[0]; // assuming one series, or handle multiple if needed
          const minutes = data.value;
          const duration = moment.duration(minutes, "minutes");
          const hours = String(Math.floor(duration.asHours())).padStart(2, "0");
          const mins = String(duration.minutes()).padStart(2, "0");
          const secs = String(duration.seconds()).padStart(2, "0");
          return `${data.name}: ${hours}:${mins}:${secs}`;
        },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
        },
      },
      grid: {
        top: "15%",
        left: "5%",
        right: "5%",
        bottom: "0%",
        containLabel: true,
      },
      dataZoom: [
        {
          type: "inside",
          show: true,
          xAxisIndex: 0,
          start: 0,
          end: 50,
        },
      ],
      xAxis: {
        type: "category",
        data: data.map((item) => item.machine_name),
        axisLabel: {
          rotate: 30,
        },
      },
      yAxis: {
        type: "value",
        name: "Downtime (mins)",
      },
      series: [
        {
          name: "Downtime",
          type: "bar",
          data: data.map((item) => item.downtime_duration),
          itemStyle: {
            color: "#5470C6",
          },
          label: {
            show: false, // Removed the label above bars
          },
        },
      ],
    };
  }
  openModel(template: any, item: any) {
    if (item == "energyHourlyCost") {
      this.energyChart(this.energyData, this.selectedEnergyDay);
    } else if (item == "revenueHourlyLoss") {
      this.revenueChart(this.revenueData, this.selectedRevenueDay);
    }
    this.modalService.open(template, {
      backdrop: "static",
      centered: true,
      size: "xl",
    });
  }
  getSteps(item: any) {
    if (item.machineType != "no_part") {
      return [
        { label: "Production Planning", status: item.productionPlanning },
        { label: "Target Entry", status: item.target },
      ];
    } else {
      return [
        { label: "Production Planning", status: item.productionPlanning },
      ];
    }
  }
  getSteps2(item: any) {
    if (item.machineType != "no_part") {
      return [
        { label: "Target : 0", status: item.target },
      ];

    }
  }
  getrevnueSteps(item: any) {
    return [
      {
        label: "Machine Cost Per Hour not configured",
        status: item.machineCostperHour,
      },
    ];
  }
  getenergyCost(item: any) {
    return [{ label: "Energy Cost", status: item.energyCost }];
  }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  getButtonIconClass(button: string): string {
    switch (button.toLowerCase()) {
      case "production":
        return "mdi-factory";
      case "rejection":
        return "mdi-cancel";
      case "downtime":
        return "mdi-timer-off";
      case "department":
        return "mdi-view-dashboard";
      default:
        return "mdi-help-circle";
    }
  }

onDepartmentTableRowClick(dept: any) {
  this.statusData1=[]
  this.showDepartmentTable = false;
  this.selectedDepartment = dept.departmentName;

  let data = this.departmentData.filter(
    (el) => el.departmentName === dept.departmentName
  );
  this.selectedDepartmentShift = data[0]['shiftData'];
  this.departmentcurrentShiftData = this.currShift.getCurrentShift(
    this.selectedDepartmentShift,
    this.timeZone
  );

  if (this.departmentcurrentShiftData != undefined) {
    console.log("called")
    this.getdepartmentAlertData();
    this.getproductionData();
    this.statusData();
    this.rejectionData();
    this.getDowntimeData();
  }
}
backToDepartmentTable() {
  this.statusData1=[]
  this.statusDatas={}
    this.productionChart(this.statusData1, this.selectedProductionDay);
     this.statusChart(this.statusDatas, this.selectedProductionDay);
  this.showDepartmentTable = true;
  this.selectedButton = 'Production'; // reset to default tab
}
  ngOnDestroy() {
    this.cancelPreviousRequests$.next();
    this.cancelPreviousRequests$.complete();
    this.insightsData = [];
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }
}
